import React from 'react';
import IndexNews from "../IndexNews/IndexNews";
import {GET_NEWS_INDEX} from "../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useQuery} from "@apollo/client";

function QueryNewsIndex (props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}

    const { loading, error, data} = useQuery(GET_NEWS_INDEX);
    if (loading) return <p><TextSource ArrIndex= 'index0025'>Внимание - загружаются новости</TextSource></p>;
    if (error) return `loading error! ${error.message}`;
    const ToNewArray2 = data.getNewsIndex.map(function(document) {
        let MyAlldate = document.NewsDate.split('-');
        let MyYear = MyAlldate[0];
        let MyMonth = MyAlldate[1];
        let MyDate = MyAlldate[2];
        return [JSON.parse(document.Title.split("'").join(''))[props.lang], MyYear, MyMonth, MyDate, MyAlldate, JSON.parse(document.TextForMain.split("'").join(''))[props.lang], document._id]
    }).sort(function(a, b){return b[4] - a[4]});
    return (
        <IndexNews ArrayNews={ToNewArray2} data={props.data} lang={props.lang} PrerenderTexts={props.PrerenderTexts}/>
    )}
export default QueryNewsIndex